import React from 'react';

import SelectFiled from '../select-field/SelectField';

interface CustomInputSelectBoxInterface {
  inputLabel: string;
  inputType: string;
  placeholder: string;
  inputValue: number | string;
  inputName: string;
  selectName: string;
  handleValueChange: (name: string, changeValue: string | number) => void;
  selectValue: string | number;
  selectOptions: {
    value: string | number;
    label: string;
  }[];
  valueRequired?: boolean;
  errorMessage?: string;
  error?: boolean;
  disabled?: boolean;
}

/**
 * Custom input select box component
 * @param param0
 * @returns
 */
function CustomInputSelectBox({
  inputLabel,
  inputType,
  placeholder,
  inputValue,
  inputName,
  handleValueChange,
  selectValue,
  selectName,
  selectOptions,
  valueRequired,
  errorMessage,
  error,
  disabled,
}: CustomInputSelectBoxInterface) {
  return (
    <div className="custom-input-select-box-warp">
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-input-box">
        <div className={`custom-input-container ${error && 'error'}`}>
          <input
            style={{ cursor: disabled ? 'not-allowed' : 'text' }}
            type={inputType}
            placeholder={placeholder}
            value={inputValue}
            onChange={(event) => handleValueChange(inputName, event.target.value)}
            required={valueRequired}
            disabled={disabled}
          />
        </div>
        <SelectFiled
          disabled={disabled}
          inputLabel=""
          options={selectOptions}
          name={selectName}
          selectedValue={selectValue}
          onChangeValue={handleValueChange}
        />
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}
CustomInputSelectBox.defaultProps = {
  valueRequired: false,
  error: false,
  errorMessage: '',
  disabled: false,
};

export default CustomInputSelectBox;
